import * as Redux from "react-redux";

import { useMerchantModel, useSaveFormCompletion } from "client/hooks";
import { SalesChannel } from "client/lib/apt-merchant";
import { errorActions } from "client/store";

interface SubmitBusinessOwner {
  completeBusinessOwners: () => Promise<void>;
}

export const useSubmitBusinessOwner = (
  agreementAccepted: boolean
): SubmitBusinessOwner => {
  const {
    formatMerchantForSave,
    formatMerchantForStoreInfo,
    merchant,
    removeFieldSetFromCollection,
    validateMerchant,
  } = useMerchantModel();
  const dispatch = Redux.useDispatch();
  const { mutate: _completeBusinessOwners } = useSaveFormCompletion(dispatch);

  const shouldShowStoreLocations =
    merchant.storeDetails?.salesChannel?.value &&
    (["Online and In-store", "In-store Only"] as SalesChannel[]).includes(
      merchant.storeDetails?.salesChannel?.value
    );

  const storeData = formatMerchantForStoreInfo();
  const saveData = formatMerchantForSave();

  const completeBusinessOwners = async () => {
    if (!agreementAccepted) {
      dispatch(
        errorActions.setError(
          "Please accept merchant agreement and privacy policy before submitting."
        )
      );
      return;
    }

    const someOwnersHaveErrors = merchant.owners.some(
      (owner) => !validateMerchant(owner)
    );
    if (someOwnersHaveErrors) {
      dispatch(
        errorActions.setError("You have errors with one or more owners")
      );
      return;
    }

    if (shouldShowStoreLocations) {
      if (merchant.locations.some((location) => !validateMerchant(location))) {
        dispatch(
          errorActions.setError(
            "You have missing or invalid store location fields"
          )
        );
        return;
      }
    } else {
      merchant.locations.map((_, i) =>
        removeFieldSetFromCollection("locations", i)
      );
    }

    _completeBusinessOwners({
      saveData,
      storeData,
      formCompletionData: {
        businessOwnerForm: true,
      },
    });
  };

  return {
    completeBusinessOwners,
  };
};
